module.exports = __webpack_public_path__ + "static/s3-object1-029a62e2f677ea7dbfe2fe359e03573f.png";